








































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import FacilityData from '@/ts/FacilityData';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';

@Component
export default class BookFacilityDateOverlay extends Mixins(LocalizationMethods) {
    public date: any = null;
    public calendarMask: any = {
        title: 'MMMM YYYY',
        weekdays: 'WWW',
    };

    constructor() {
        super();
    }

    get bookingDate(): string {
        return this.$store.getters['SharedFacilities/getFacilityBookingDate'];
    }

    get facility(): FacilityData {
        return this.$store.getters['SharedFacilities/getUserSelectedFacility'];
    }

    get facilityUnavailabilityDays(): any {
        return this.facility.unavailableWeekDays;
    }

    // Format ignoring moment js default timezone
    get formatDate() {
        if (this.date !== null) {
            const calendarDate = new Date(this.date);
            const year  = calendarDate.getFullYear();
            const month = calendarDate.getMonth() + 1 < 10 ? '0' + (calendarDate.getMonth() + 1) : calendarDate.getMonth() + 1;
            const day   = calendarDate.getDate() < 10 ? '0' + calendarDate.getDate() : calendarDate.getDate();

            return `${day}-${month}-${year}`;
        }

        return '-';
    }

    public saveDate() {
        this.$store.commit(Mutations.SET_FACILITY_BOOKING_DATE, this.formatDate);

        this.$store.dispatch(Actions.FETCH_FACILITY_UNAVAILABILITY, {
            facilityId: this.facility.id,
            date: this.formatDate,
        });

        this.cancel();
    }

    public cancel() {
        this.$store.commit(Mutations.SET_BOOK_FACILITY_DATE_OVERLAY_VISIBILITY, false);
    }

    public toDate(dateStr: any) {
        const parts = dateStr.split('-');

        return new Date(parts[2], parts[1] - 1, parts[0]);
    }

    public created() {
        if (this.bookingDate !== null) {
            this.date = this.toDate(this.bookingDate);
        }
    }
}
